"use client";

import { useEffect } from "react";

export interface UseMediaPlayerKeyboardOptions {
	enabled: boolean;
	onTogglePlayPause: () => void;
	onSkipBack?: () => void;
	onSkipForward?: () => void;
	onSeekToStart?: () => void;
	onSeekToEnd?: () => void;
}

export function useMediaPlayerKeyboard({
	enabled,
	onTogglePlayPause,
	onSkipBack,
	onSkipForward,
	onSeekToStart,
	onSeekToEnd,
}: UseMediaPlayerKeyboardOptions): void {
	useEffect(() => {
		if (!enabled) {
			return;
		}

		function handleKeyDown(event: KeyboardEvent) {
			const target = event.target;
			if (
				target instanceof HTMLElement &&
				(target.isContentEditable ||
					target.tagName === "INPUT" ||
					target.tagName === "TEXTAREA" ||
					target.tagName === "SELECT")
			) {
				return;
			}

			switch (event.code) {
				case "Space":
					event.preventDefault();
					onTogglePlayPause();
					break;
				case "ArrowLeft":
					event.preventDefault();
					onSkipBack?.();
					break;
				case "ArrowRight":
					event.preventDefault();
					onSkipForward?.();
					break;
				case "Home":
					event.preventDefault();
					onSeekToStart?.();
					break;
				case "End":
					event.preventDefault();
					onSeekToEnd?.();
					break;
				default:
					break;
			}
		}

		window.addEventListener("keydown", handleKeyDown);
		return () => window.removeEventListener("keydown", handleKeyDown);
	}, [
		enabled,
		onTogglePlayPause,
		onSkipBack,
		onSkipForward,
		onSeekToStart,
		onSeekToEnd,
	]);
}
